/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCorsAllowedOriginDto
 */
export interface UpdateCorsAllowedOriginDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCorsAllowedOriginDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCorsAllowedOriginDto
     */
    description: string;
}

/**
 * Check if a given object implements the UpdateCorsAllowedOriginDto interface.
 */
export function instanceOfUpdateCorsAllowedOriginDto(value: object): value is UpdateCorsAllowedOriginDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function UpdateCorsAllowedOriginDtoFromJSON(json: any): UpdateCorsAllowedOriginDto {
    return UpdateCorsAllowedOriginDtoFromJSONTyped(json, false);
}

export function UpdateCorsAllowedOriginDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCorsAllowedOriginDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'description': json['description'],
    };
}

export function UpdateCorsAllowedOriginDtoToJSON(json: any): UpdateCorsAllowedOriginDto {
    return UpdateCorsAllowedOriginDtoToJSONTyped(json, false);
}

export function UpdateCorsAllowedOriginDtoToJSONTyped(value?: UpdateCorsAllowedOriginDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'description': value['description'],
    };
}

